import { render } from "./PastLayout.vue?vue&type=template&id=1eb6a232&ts=true"
import script from "./PastLayout.vue?vue&type=script&lang=ts"
export * from "./PastLayout.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__